import { render, staticRenderFns } from "./BookingStudent.vue?vue&type=template&id=633fc05c&scoped=true&"
import script from "./BookingStudent.vue?vue&type=script&lang=js&"
export * from "./BookingStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633fc05c",
  null
  
)

export default component.exports